module.exports = __webpack_public_path__ + "media/img/why/calendar-af7c11133c5ed6ec1427f0c2f023e2f0.png";